var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageSize"},[_c('img',{staticClass:"wh100",attrs:{"src":"https://image.giantgocloud.com/www/ImageMapping/image/20240429/85B012E8C94C4AAE867FBFCA83530B0B.png"}}),_c('div',{staticClass:"analysisReport_pages4_box"},[_c('div',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("健康管理方案")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }